import { useContext } from 'react';
import { ZoneContext, ZoneContextValue } from './ZoneContext';

export const useZoneContext = () => useContext<ZoneContextValue>(ZoneContext);
